import React, { lazy, useEffect, useState, useCallback } from 'react';
import { Route, Switch } from "react-router-dom";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import { useDispatch, useMappedState } from 'redux-react-hook';
import ROUTES from "./routesConstants";


// const Login = lazy(() => import('./scenes/Login'));
// const SignUp = lazy(() => import('./scenes/SignUp'));
// const Search = lazy(() => import('./scenes/Search'));
// const Templates = lazy(() => import('./scenes/Templates'));


const RegisterNewUser = lazy(() => import('./scenes/RegisterNewUser'));
const SignUpBusiness = lazy(() => import('./scenes/SignUpBusiness'));
const SignInBusiness = lazy(() => import('./scenes/SignInBusiness'));
const User = lazy(() => import('../src/components/User'));
const UpdatePassword = lazy(() => import('./scenes/UpdatePassword'));

const BusinessRegister = lazy(() => import('./scenes/BusinessRegister'));
const Products = lazy(() => import('./scenes/Products'));
const GestionPedidos = lazy(() => import('./scenes/GestionPedidos'));
const RegistroEmpleados = lazy(() => import('./scenes/RegistroEmpleados'));
const ForgotPassword = lazy(() => import('./scenes/ForgotPassword'));

interface IRoute {
    child: any;
    isAuthenticated: boolean;
  };

export default ({ childProps }: any) => {

// export default ({ child, isAuthenticated }: IRoute) => {
    console.log("[Routes] props", childProps)
//     console.log("isAuthenticated", isAuthenticated)
useEffect(() => {
    console.log("[Routes] props",childProps)
  }, [childProps])
    return (

        <Switch>
        
            <UnauthenticatedRoute path={ROUTES.ROOT} exact component={SignInBusiness} props={childProps} />
            <UnauthenticatedRoute path={ROUTES.LOGIN} exact component={SignInBusiness} props={childProps} />
            <UnauthenticatedRoute path={ROUTES.SIGNUP} exact component={SignUpBusiness} props={childProps} />
            <UnauthenticatedRoute path={ROUTES.FORGOT_PASSWORD} exact component={ForgotPassword} props={childProps} />

            <AuthenticatedRoute path={ROUTES.UPDATE_USER} exact component={User} props={childProps} />
            <AuthenticatedRoute path={ROUTES.UPDATE_PASSWORD} exact component={UpdatePassword} props={childProps} />
            <AuthenticatedRoute path={ROUTES.OLD_BUSINESS_REGISTER} exact component={BusinessRegister} props={childProps} />
            <AuthenticatedRoute path={ROUTES.OLD_PRODUCTS} exact component={Products} props={childProps} />
            <AuthenticatedRoute path={ROUTES.OLD_GESTION_PEDIDOS} exact component={GestionPedidos} props={childProps} />
            <AuthenticatedRoute path={ROUTES.OLD_REGISTRO_EMPLEADOS} exact component={RegistroEmpleados} props={childProps} />

        </Switch>


    )
};

